export default (monthData, pageData) => {

  const m = {
    pageData,
    monthData,
  };
  const init = () => {
    m.root = document.querySelector('.le-side-month').parentElement;

    buildAccordion();

    m.root.classList.remove('_skelton');
    m.root.removeAttribute('aria-hidden');
  }

  const buildAccordion = () => {
    const monthList = m.root.querySelector('.le-side-month__list');
    const monthListItems = monthList.children;

    [].forEach.call(monthListItems, monthListItem => {
      const monthNum = monthListItem.dataset.month;
      if (Number(monthNum) == m.pageData.displayMonth) {
        monthListItem.classList.add('is-current');
      }
      if (!m.monthData[`_${monthNum}`]) {
        monthListItem.classList.add('_disabled');
      }
    })
  }

  init();
}
